import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {getRequestSelfService, emptyRequestSelfService} from './Module';
import {Form, Select as SelectInput} from 'antd';
import jMoment from 'components/classes/Jmomen';
import uuidv1 from 'uuid/v1';
import MaterialIcon from 'components/common/MaterialIcon';

@connect((state) => ({
  selfService: state.FormBuilder.Common.SelectSelfService.selfService,
}), {
  getRequestSelfService,
  emptyRequestSelfService,
})
@autobind
/**
 *
 */
export default class SelectSelfServiceInfo extends React.PureComponent {
  static propTypes = {
    inline: PropTypes.bool,
    label: PropTypes.string,
    selfServiceId: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    selfService: PropTypes.object,
    getRequestSelfService: PropTypes.func,
    emptyRequestSelfService: PropTypes.func,
  };

  static defaultProps = {
    inline: true,
    label: undefined,
  };

  /**
   *
   * @param {object} props
   */
  constructor(props) {
    super(props);
    this.state = {
      selfService: {},
      render: true,
    };
  }


  /**
   *
   */
  componentDidMount() {
    const {getRequestSelfService} = this.props;
    getRequestSelfService(this.props.selfServiceId, {
      includes: ['food:id,title', 'meal:id,title,color', 'self:id,title'],
    }, (r) => {
      this.setState({selfService: r});
    });
  }

  /**
   *
   * @param {Object} np
   */
  componentWillReceiveProps(np) {
    if (!app._.isEqual(np.selfServiceId, this.props.selfServiceId)) {
      np.getRequestSelfService(np.selfServiceId, {
        includes: ['food:id,title', 'meal:id,title,color', 'self:id,title'],
      }, (r) => {
        this.setState({selfService: r});
      });
    }
  }

  /**
   *
   */
  componentWillUnmount() {
    super.componentWillUnmount();
    this.props.emptyRequestSelfService();
  }


  /**
   *
   * @return {Object}
   * @private
   */
  _inline() {
    const {inline} = this.props;

    if (inline) {
      return {
        labelCol: {span: 6},
        wrapperCol: {span: 18},
      };
    }

    return {};
  }

  /**
   *
   * @return {XML}
   */
  render() {
    const {selfService, label} = this.props;

    return (
      <span>
        {`${selfService && selfService.title}`}
        </span>
    );
  }
}
